/*
 Il minimo che serve per descrivere un avviso: chi, quale corso, e che cosa non va.

 E' un tipo strutturale e non CertificateNotice perche' i chiamanti sono due e portano forme
 diverse — il caricamento manda CertificateNotice, la validazione massiva CertificateRejection,
 che ha in piu' l'id dell'attestato. Quello che hanno in comune e' esattamente questo.
*/
type AvvisoDescrivibile = {
  nome: string | null;
  cognome: string | null;
  codiceCorso: string | null;
  titoloCorso: string | null;
  motivo: string;
};

/*
 Descrive in forma leggibile gli attestati su cui c'e' qualcosa da dire.

 Il motivo arriva gia' scritto dal backend: qui si antepone soltanto di chi e di quale corso si
 tratta, perche' l'operatore possa riconoscere il documento che ha in mano senza aprire il file.

 Sta in un modulo proprio e non in utils.tsx perche' quel file importa axios: e' una funzione
 pura e deve restare testabile senza impalcatura, come pipeline.ts e selezione.ts.
*/
export function descriviAvvisi(avvisi: AvvisoDescrivibile[]): string {
  return avvisi
    .map((avviso) => {
      const discente = [avviso.cognome, avviso.nome]
        .filter(Boolean)
        .join(" ");
      const corso = avviso.titoloCorso ?? avviso.codiceCorso ?? "";
      const intestazione = [discente, corso].filter(Boolean).join(" — ");
      return intestazione ? `${intestazione}: ${avviso.motivo}` : avviso.motivo;
    })
    .join("\n");
}
